import React, { useState } from "react";
import { ReactComponent as DashboardLogo } from "./assets/images/migration.svg";
import ActualImport from "./components/ActualImport";
import PlanImport from "./components/PlanImport";
import ContentHeader from "../../components/ContentHeader";

import "./assets/css/style.css";

const System: React.FC = () => {
    const [content, setContent] = useState<string>("actual");

    const changeContent = (content: string) => {
        setContent(content);
    };

    return (
        <div className="wrapperApp">
            <ContentHeader
                title="System"
                Icon={DashboardLogo}
                breadcrumb={["System"]}
            />
            <div id="content">
                <div className="tabs">
                    <div className="tabs__buttons">
                        <button
                            className={`tabs__tablinks ${content === "actual" ? "tabs__tablinks--active" : ""
                                }`}
                            onClick={() => {
                                changeContent("actual");
                            }}
                        >
                            Actual
                        </button>
                        <button
                            className={`tabs__tablinks ${content === "plan" ? "tabs__tablinks--active" : ""
                                }`}
                            onClick={() => {
                                changeContent("plan");
                            }}
                        >
                            Plan
                        </button>
                    </div>
                    <div className="tabs__tabcontent">
                        {content === "actual" ? (
                            <ActualImport />
                        ) : (
                            <PlanImport />
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};
export default System;
